var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'toast',staticClass:"toast-container",class:_vm.type,style:({
    opacity: _vm.visible ? 1 : 0,
    top: '60px',
    right: _vm.visible ? '0px' : ("-" + _vm.width),
    'border-top-left-radius': (_vm.border_radius + "px"),
    'border-bottom-left-radius': (_vm.border_radius + "px")
  }),on:{"click":_vm.hide}},[(_vm.type === 'error')?_c('img',{attrs:{"src":_vm.error_icon,"width":"16","height":"16"}}):_vm._e(),_vm._v(" "),(_vm.type === 'info')?_c('i',{staticClass:"fa fa-times",attrs:{"width":"16","height":"15"}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }